import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "lotto-wrapper",
  class: "contents-wrapper"
}
const _hoisted_2 = { id: "lotto-create" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "create-head" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "create-title" }, "번호 생성"),
  /*#__PURE__*/_createElementVNode("p", { class: "create-sub" }, "왼쪽에서 번호를 만들면 오른쪽에 결과와 역대 당첨 이력이 바로 표시됩니다.")
], -1)
const _hoisted_4 = { class: "create-layout" }
const _hoisted_5 = { class: "cl-left" }
const _hoisted_6 = { class: "section-card qr-card" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "종이 복권 불러오기", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "section-desc" }, "매장에서 산 로또 용지의 QR을 읽어 구매 내역으로 저장합니다. 자동·수동·반자동 구분도 함께 기록돼요.", -1)
const _hoisted_9 = { class: "qr-paste" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "qr-paste-label" }, "QR 링크 직접 입력", -1)
const _hoisted_11 = { class: "qr-paste-row" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "qr-paste-error"
}
const _hoisted_14 = {
  key: 2,
  class: "result-area"
}
const _hoisted_15 = {
  key: 1,
  class: "result-drw"
}
const _hoisted_16 = { class: "game-list" }
const _hoisted_17 = { class: "section-card favorite-section" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "번호 즐겨찾기", -1)
const _hoisted_19 = {
  key: 0,
  class: "result-empty compact"
}
const _hoisted_20 = {
  key: 1,
  class: "favorite-list"
}
const _hoisted_21 = { class: "favorite-info" }
const _hoisted_22 = { class: "favorite-name" }
const _hoisted_23 = { class: "favorite-balls" }
const _hoisted_24 = { class: "favorite-actions" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "section-card strategy-section" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "자동·전략 생성", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "section-lead" }, "원하는 방식을 고르면 5게임을 자동으로 만들어 드려요.", -1)
const _hoisted_30 = { class: "strategy-group-label" }
const _hoisted_31 = { class: "strategy-btn-list" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "strategy-btn-title" }
const _hoisted_34 = { class: "strategy-btn-desc" }
const _hoisted_35 = { class: "section-card fixed-section" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "직접 고르기", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "section-lead" }, [
  /*#__PURE__*/_createTextVNode(" 꼭 넣고 싶은 번호는 "),
  /*#__PURE__*/_createElementVNode("b", null, "고정"),
  /*#__PURE__*/_createTextVNode("(최대 5개), 빼고 싶은 번호는 "),
  /*#__PURE__*/_createElementVNode("b", null, "제외"),
  /*#__PURE__*/_createTextVNode("로 지정하면 나머지 자리를 랜덤으로 채워 5게임을 만듭니다. ")
], -1)
const _hoisted_38 = { class: "fixed-mode-btns" }
const _hoisted_39 = { class: "fixed-number-grid" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "exclude-x"
}
const _hoisted_42 = { class: "fixed-info-row" }
const _hoisted_43 = {
  key: 0,
  class: "fixed-selected"
}
const _hoisted_44 = {
  key: 1,
  class: "exclude-selected"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "section-card result-panel" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "생성된 번호", -1)
const _hoisted_48 = { class: "strategy-result-header" }
const _hoisted_49 = { class: "result-title-group" }
const _hoisted_50 = { class: "result-strategy-name" }
const _hoisted_51 = { class: "result-meta" }
const _hoisted_52 = { class: "game-list" }
const _hoisted_53 = { class: "strategy-action-btns" }
const _hoisted_54 = {
  key: 1,
  class: "result-empty"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "result-empty-icon" }, "🎱", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "result-empty-text" }, "왼쪽에서 번호를 생성하면 여기에 나타납니다", -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  key: 0,
  class: "section-card sim-loading-card"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "sim-loading-spinner" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", null, "역대 당첨 이력 조회 중…", -1)
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = {
  key: 1,
  class: "section-card simulation-section"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "역대 당첨 이력 판정", -1)
const _hoisted_64 = { class: "section-desc" }
const _hoisted_65 = { class: "sim-summary" }
const _hoisted_66 = { class: "sim-count" }
const _hoisted_67 = {
  key: 0,
  class: "sim-hits"
}
const _hoisted_68 = { class: "sim-hits-title" }
const _hoisted_69 = { class: "sim-hits-list" }
const _hoisted_70 = { class: "sim-hit-drw" }
const _hoisted_71 = { class: "sim-hit-nums" }
const _hoisted_72 = {
  key: 0,
  class: "sim-hit-prize"
}
const _hoisted_73 = {
  key: 1,
  class: "sim-hits-empty"
}
const _hoisted_74 = { class: "sim-total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QRScannerDialog = _resolveComponent("QRScannerDialog")!
  const _component_LottoResult = _resolveComponent("LottoResult")!
  const _component_LottoBuyGame = _resolveComponent("LottoBuyGame")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            (!_ctx.isDesktop())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "create-btn qr-btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openQRScanner && _ctx.openQRScanner(...args)))
                }, "📷 카메라로 QR 스캔"))
              : _createCommentVNode("", true),
            (_ctx.isScanning)
              ? (_openBlock(), _createBlock(_component_QRScannerDialog, {
                  key: 1,
                  onQrScanned: _ctx.handleScannedData,
                  onClose: _ctx.closeQRScanner
                }, null, 8, ["onQrScanned", "onClose"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.qrPasteUrl) = $event)),
                  type: "text",
                  class: "qr-paste-input",
                  placeholder: "QR을 열면 나오는 m.dhlottery.co.kr 링크를 붙여넣으세요"
                }, null, 512), [
                  [_vModelText, _ctx.qrPasteUrl]
                ]),
                _createElementVNode("button", {
                  class: "create-btn qr-load-btn",
                  disabled: !_ctx.qrPasteUrl.trim(),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadQrFromPaste && _ctx.loadQrFromPaste(...args)))
                }, "불러오기", 8, _hoisted_12)
              ]),
              (_ctx.qrPasteError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.qrPasteError), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.qrBuyList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_ctx.qrLottoResult.drwNo > 0)
                    ? (_openBlock(), _createBlock(_component_LottoResult, {
                        key: 0,
                        lottoResult: _ctx.qrLottoResult
                      }, null, 8, ["lottoResult"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.qrDrwNo) + "회차", 1)),
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qrBuyList, (gameBuy, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'qr-' + idx,
                        class: "game-item"
                      }, [
                        _createVNode(_component_LottoBuyGame, {
                          lottoGame: gameBuy,
                          hideRank: true
                        }, null, 8, ["lottoGame"])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("button", {
                    class: "save-btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveQRGame()))
                  }, "구매 저장")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            (_ctx.favorites.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, "저장된 즐겨찾기가 없습니다"))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favorites, (fav) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'fav-' + fav.id,
                      class: "favorite-item"
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(fav.favoriteName || '즐겨찾기'), 1),
                        _createElementVNode("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fav.getNumbers(), (num, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'fb-' + fav.id + '-' + i,
                              class: _normalizeClass(["fav-ball", _ctx.getFixedColorClass(num)])
                            }, _toDisplayString(num), 3))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("button", {
                          class: "fav-use-btn",
                          onClick: ($event: any) => (_ctx.useFavorite(fav))
                        }, "사용", 8, _hoisted_25),
                        _createElementVNode("button", {
                          class: "fav-delete-btn",
                          onClick: ($event: any) => (_ctx.deleteFavoriteItem(fav.id))
                        }, "삭제", 8, _hoisted_26)
                      ])
                    ]))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _hoisted_29,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strategyGroups, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "strategy-group",
                key: group.label
              }, [
                _createElementVNode("div", _hoisted_30, _toDisplayString(group.label), 1),
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (strategy) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: strategy.key,
                      class: _normalizeClass(["strategy-btn", { active: _ctx.activeStrategy === strategy.key }]),
                      onClick: ($event: any) => (_ctx.executeStrategy(strategy.key))
                    }, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(strategy.title), 1),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(strategy.desc), 1)
                    ], 10, _hoisted_32))
                  }), 128))
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                class: _normalizeClass({ active: _ctx.fixedMode === 'include' }),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fixedMode = 'include'))
              }, "고정할 번호", 2),
              _createElementVNode("button", {
                class: _normalizeClass({ active: _ctx.fixedMode === 'exclude' }),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fixedMode = 'exclude'))
              }, "제외할 번호", 2)
            ]),
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(45, (n) => {
                return _createElementVNode("button", {
                  key: 'fn-' + n,
                  class: _normalizeClass(["fixed-number-btn", [
                  _ctx.getFixedColorClass(n),
                  { selected: _ctx.fixedNumbers.includes(n) },
                  { excluded: _ctx.excludeNumbers.includes(n) },
                ]]),
                  onClick: ($event: any) => (_ctx.toggleNumber(n))
                }, [
                  _createTextVNode(_toDisplayString(n) + " ", 1),
                  (_ctx.excludeNumbers.includes(n))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, "✕"))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_40)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_42, [
              (_ctx.fixedNumbers.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, " 고정: " + _toDisplayString(_ctx.fixedNumbers.sort((a, b) => a - b).join(', ')), 1))
                : _createCommentVNode("", true),
              (_ctx.excludeNumbers.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, " 제외: " + _toDisplayString(_ctx.excludeNumbers.sort((a, b) => a - b).join(', ')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "create-btn",
              disabled: _ctx.fixedNumbers.length === 0 && _ctx.excludeNumbers.length === 0,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createFixedGame && _ctx.createFixedGame(...args)))
            }, " 생성 (고정 " + _toDisplayString(_ctx.fixedNumbers.length) + "개, 제외 " + _toDisplayString(_ctx.excludeNumbers.length) + "개) ", 9, _hoisted_45)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["cl-right", { 'pane-mode': _ctx.simResult !== null || _ctx.simLoading }])
        }, [
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            (_ctx.currentGameList.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.currentResultName), 1),
                      _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.lastDrawNo) + "회차 응모 · " + _toDisplayString(_ctx.currentGameList.length) + "게임 · " + _toDisplayString(_ctx.formatKRW(_ctx.currentGameList.length * 1000)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentGameList, (gameBuy, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'cur-' + idx,
                        class: "game-item"
                      }, [
                        _createVNode(_component_LottoBuyGame, {
                          lottoGame: gameBuy,
                          hideRank: true
                        }, null, 8, ["lottoGame"])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("button", {
                      class: "save-btn",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveCurrent && _ctx.saveCurrent(...args)))
                    }, "구매 저장"),
                    _createElementVNode("button", {
                      class: "save-btn fav-outline",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addCurrentToFavorite && _ctx.addCurrentToFavorite(...args)))
                    }, "⭐ 즐겨찾기")
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_57))
          ]),
          (_ctx.simLoading && _ctx.simResult === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_61))
            : _createCommentVNode("", true),
          (_ctx.simResult !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("p", _hoisted_64, [
                  _createTextVNode("생성된 번호를 "),
                  _createElementVNode("b", null, "역대 " + _toDisplayString(_ctx.simResult.totalDraws) + "회차", 1),
                  _createTextVNode(" 전체에 대입했을 때의 결과예요. (실제 당첨과 무관한 참고용)")
                ]),
                _createElementVNode("div", _hoisted_65, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.simResult.rankCounts, (count, rank) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "sim-item",
                      key: 'sim-' + rank
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["sim-rank", 'sim-rank-' + rank])
                      }, _toDisplayString(rank === '6' ? '낙첨' : rank + '등'), 3),
                      _createElementVNode("div", _hoisted_66, _toDisplayString(count) + "회", 1)
                    ]))
                  }), 128))
                ]),
                (_ctx.simResult.hits.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, "당첨된 회차 (" + _toDisplayString(_ctx.simResult.hits.length) + "건)", 1),
                      _createElementVNode("div", _hoisted_69, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.simResult.hits, (hit, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'hit-' + idx,
                            class: "sim-hit-item"
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["sim-hit-rank", 'sim-rank-' + hit.rank])
                            }, _toDisplayString(hit.rank) + "등", 3),
                            _createElementVNode("span", _hoisted_70, _toDisplayString(hit.drwNo) + "회차", 1),
                            _createElementVNode("span", _hoisted_71, _toDisplayString(hit.numbers.join(', ')), 1),
                            (hit.prize > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(_ctx.formatKRW(hit.prize)), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_73, "역대 회차 중 3등 이상 당첨된 기록은 없어요.")),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", null, "총 대입 게임: " + _toDisplayString(_ctx.getMoneyFormat(_ctx.simResult.totalGames)), 1),
                  _createElementVNode("div", null, "가상 투자: " + _toDisplayString(_ctx.formatKRW(_ctx.simResult.totalGames * 1000)), 1),
                  _createElementVNode("div", null, "가상 당첨금: " + _toDisplayString(_ctx.formatKRW(_ctx.simResult.totalPrize)), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sim-roi", { positive: _ctx.simResult.totalPrize > _ctx.simResult.totalGames * 1000 }])
                  }, " 회수율: " + _toDisplayString(((_ctx.simResult.totalPrize / (_ctx.simResult.totalGames * 1000)) * 100).toFixed(1)) + "% ", 3)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}